import { Storage } from "lib/firebase";

export async function handleUpload(file, SKU, supplier) {
    const stringData = file.base64.split(",");
    await Storage.ref(`partners/${supplier}/${SKU}/${file.name}`).putString(
        stringData[1],
        "base64"
    );

    const url = await Storage.ref(`partners/${supplier}/${SKU}`)
        .child(file.name)
        .getDownloadURL();
    return url;
};
